import { render, staticRenderFns } from "./ListaPrecio.vue?vue&type=template&id=70c0793a"
import script from "./ListaPrecio.vue?vue&type=script&lang=js"
export * from "./ListaPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports